import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { AgGridReact } from 'ag-grid-react';
import { useParams } from 'react-router-dom'
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { AssetDropDown } from "../../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { getAsset } from "../../actions/assetAction";
import { TopBar } from '../../shared/topBar/TopBar';
import { LicenseManager } from "ag-grid-enterprise";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router";
import { DateRangePicker } from "rsuite";
import { getTransactionsList } from "../../actions/assetTransactionsAction";
import download from "../Images/download.svg";
import { exportToExcelUsingRef } from '../../utils/excelExporter';
import { sbaAxios } from "../../utils/sbaAxios";
import { getCustomSettings, updateCustomSettings,getUserPageAccess,deleteTransaction} from "../../../config/apiConfig";
import { HoverList } from './TransactionMenus';
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { ToastContainer } from "react-toastify";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { SBNotify } from "../../utils/sbNotify";
import { Modal } from "react-bootstrap";
export const TransactionList = () => {

  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const transactionsRef = useRef();
  const [gridApi, setGridApi] = useState();
  const [colDef, setColDef] = useState([]);
  const oneMonthAgo = new Date();
  const oneMonthAfter = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  oneMonthAfter.setMonth(oneMonthAfter.getMonth() + 1);
  const assetTransFilters=JSON.parse(localStorage.getItem("AssetTransactionFilter"));
  const startDate= assetTransFilters?.startDate ? new Date(assetTransFilters?.startDate) : oneMonthAgo; 
  const endDate= assetTransFilters?.endDate ? new Date(assetTransFilters?.endDate) : oneMonthAfter; 
  const [selectedFromDate, setSelectedFromDate] = useState(startDate);
  const [selectedToDate, setSelectedToDate] = useState(endDate);
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [showdeleteModal,setShowdeleteModal]=useState(false);
  const [transactionId,setTransactionId]=useState(0);
  const [isHovered, setIsHovered] = useState(false);
    const [transactionEditAccess, setTransactionEditAccess] = useState(false);
    const [transactionAddAccess, setTransactionAddAccess] = useState(false);
    const [transactionDeleteAccess, setTransactionDeleteAccess] = useState(false);
    const [dateRange, setDateRange] = useState( [ startDate ,endDate]);
  const handleListMouseEnter = () => {
    setIsHovered(true);
  };

  const handleListMouseLeave = () => {
    setIsHovered(false);
  };

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
  const currentAsset = Gstate.asset.asset || {};
  const AssetListDDL = Gstate.assetDDL.assetList || [];
  const TransactionListData = Gstate.transactionList.transactionList || [];
  const isEditable = Gstate.authorizationData.isEditable;
  
  useEffect(() => {
    getTransactionEditAccess();
    document.title="Asset Transactions"
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.AssetId));
      dispatch(getTransactionsList(params.AssetId, selectedFromDate.toISOString(), selectedToDate.toISOString()));
      getCustomSetting();
  }, [params.AssetId,transactionDeleteAccess]);
  const AssetDDChanged = (e) => {
    e.value && history(`${UrlPath.Transactions}${e.value.AssetId}`);
    e.value && dispatch(getAsset(e.value.AssetId));
  };
  const handleDateChange = (e) => {
      if (e) {
          const newStartDate = e.value.start !== null ? e.value.start : selectedFromDate;
          const newEndDate = e.value.end !== null ? e.value.end : selectedToDate;
          setDateRange([newStartDate, newEndDate])
          setSelectedFromDate(newStartDate);
          setSelectedToDate(newEndDate);
    }
  };

  const GoClick = () => {
    const assetTransactionFilter={
      startDate: selectedFromDate.toISOString(),
      endDate:selectedToDate.toISOString()
    }
    localStorage.setItem('AssetTransactionFilter',JSON.stringify(assetTransactionFilter));
    dispatch(getTransactionsList(params.AssetId, selectedFromDate.toISOString(), selectedToDate.toISOString()));
  };
  const navigateToTransactionEdit=(TransData)=>{
    const transType=TransData.TransType.replace(/\s/g, '');
    const TransId=TransData?.TransId || 0;
    if(transType==="RedeemtoCash")
    history(`${UrlPath.Transactions}${'Redemption'}/${TransId}/${params.AssetId}/1`);
    else
    {
    if(transType==="DistributiontoHoldbacks")
    history(`${UrlPath.Transactions}${'Distribution'}/${TransId}/${params.AssetId}/1`);
    else
    history(`${UrlPath.Transactions}${transType}/${TransId}/${params.AssetId}/1`);
    }

    
}
  const ActionColRender=(e)=>{
    return <>  <i className={"fas fa-edit"} style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={()=>{navigateToTransactionEdit(e.data)}}></i>
       <i className={"fa fa-trash"} style={{ color: transactionDeleteAccess === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={()=>{(transactionDeleteAccess) && deleteModalpopup(e.data.TransId)}}></i>
    
    </>
}
  const getCustomSetting = () => {
    sbaAxios({ url: `${getCustomSettings}1007` }).then(response => {
      if (response) {
        const apiColDef = JSON.parse(response.CustomSettingsValue);
        const apiFilters =  response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
        const formattedDef = apiColDef.map(item => ({
          ...item,
          field: item.colId,
          floatingFilter:item.colId!=='action',
          valueGetter: (item.colId === "TransDate" || item.colId === "ModifiedDate") ? (e)=>{ return getDateFormatted(e,item.colId)} : (item.colId === "LocalAmount" || item.colId === "TransAmount") ? (e)=>{return currencyFormatter(e,item.colId)} :  null,
          cellRenderer: (item.colId === "LocalAmount" || item.colId === "TransAmount") ? (e)=>{return FormatCurrencyGrid(e,item.colId)} : item.colId==='action' ? ActionColRender : null ,
          cellStyle: { textAlign: (item.colId === "Shares" || item.colId === "NAV" || item.colId === "LocalAmount" || item.colId === "TransAmount") ? "right" : "left" } 
        }));
        setAppliedFilter(apiFilters);
        setColDef(formattedDef);
      }
    }).catch(error => {

      console.log(error);
    });
  };
 


  const getTransactionEditAccess = async  () => {
    try {
      const transactionAddAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=TransactionAddAccess` });
      const transactionDeleteAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=TransactionDeleteAccess` });
      const [
       
        transactionAddAccessResponse,
        transactionDeleteAccessResponse,
       
      ] = await Promise.all([
        
        transactionAddAccessPromise,
        transactionDeleteAccessPromise
      ]);
     
      setTransactionAddAccess(transactionAddAccessResponse);
      setTransactionDeleteAccess(transactionDeleteAccessResponse);
    } catch (error) {
      console.error("An error occurred:", error);
      
    }
  };
  

  const getDateFormatted = (params,fieldName) => {
    const value = params.data[fieldName];
      return moment(value).format('MM-DD-YYYY');
  };
  const FormatCurrencyGrid = (params,fieldName) => {
    var num = params.data[fieldName];
    if (num !== undefined) {
      const isNegative = num < 0;
    
      const formattedValue = isNegative
        ? `($${Math.abs(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })})`
        : `$${num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`;
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;
    } else {
      return num;
    }
  };
  const currencyFormatter = (params,fieldName) => {
    const num = params.data[fieldName];
    if (num) {
      const formattedValue = `$${(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2})}`
      return formattedValue;
    } else {
      return '';
    }
  };



  const defaultColDef = {
    sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',
  }

  const deleteModalpopup=(Id)=>
  {
      setTransactionId(Id)
      setShowdeleteModal(true);

  }
 
   // Delete Transaction
   const deleteTransactionById = async () => {
    
    try {
      const response = await sbaAxios({
        url: `${deleteTransaction}${transactionId}`,
        method: 'get',
      });
      if(response)
      {
        SBNotify({Msg:"Selected Transaction Deleted Successfully"});
      }
      else {
        SBNotify({Msg:"Transaction has Child Records", type:'error'});
      }
      setShowdeleteModal(false);
      dispatch(getTransactionsList(params.AssetId, selectedFromDate.toISOString(), selectedToDate.toISOString()));
      
     
    }
    catch (error) {
      console.error("Error Deleting transaction:", error.message);
      SBNotify({
        Msg: error.message,
        type: "error",
      });

    }

  };

    const Level = [{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` }, { BreadCrumb: `${currentAsset.AssetName} >`, Routes: `${UrlPath.AssetDetails}${params.AssetId}` }, { BreadCrumb: "Transactions", Routes: `${UrlPath.Transactions}${params.AssetId}` }]

  return (
    <>
      <TopBar label={"Transactions"} />
      <div id="TransactionList" className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <label htmlFor="select fund" className="mb-1 label">
                Asset
              </label>
              <div className="DropDownDiv input-border">
                <AssetDropDown
                  value={currentAsset}
                  onChange={AssetDDChanged}
                  data={AssetListDDL}
                />
              </div>
                      </div>

            <div className="col-md-3">
                          <label className="mb-1 label">Select Date Range</label>
                          <SBDateRangePicker
                              value={{ start: dateRange[0], end: dateRange[1] }}
                              onChange={(e) => { handleDateChange(e) }}

                          />
              {/*<div>*/}
              {/*  <DateRangePicker*/}
              {/*    className="SbaDateRage text-dark"*/}
              {/*    placeholder="Select Date Range"*/}
              {/*    value={[*/}
              {/*      selectedFromDate*/}
              {/*        ? selectedFromDate*/}
              {/*        : new Date(),*/}
              {/*      selectedToDate*/}
              {/*        ? selectedToDate*/}
              {/*        : new Date(),*/}
              {/*    ]}*/}
              {/*    format="MM/dd/yyyy"*/}
              {/*    block*/}
              {/*    character=" - "*/}
              {/*    onChange={handleDateChange}*/}
              {/*  />*/}
              {/*</div>*/}
            </div>
            <div className="col-md-1 mt-4 row-items">
              <button type="submit" className="p-sm-btn mx-1" onClick={GoClick}>
                GO
              </button>
            </div>
            <div className="col-md-5 d-flex mt-4 justify-content-end">
            
              <div>
                <button
                  type="submit"
                  className="p-sm-btn mx-1"
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                  disabled={!transactionAddAccess}
                >
                  <i className="fa-solid fa-plus" />
                  Add
                </button>
                <HoverList
                  isHovered={isHovered}
                  handleListMouseEnter={handleListMouseEnter}
                  handleListMouseLeave={handleListMouseLeave}
                />
              </div>            
              <button
                type="button"
                className="p-sm-btn mx-1"
                onClick={() => {
                  exportToExcelUsingRef(
                    transactionsRef,
                    "Transaction List.xlsx"
                  );
                }}
              >
                <img src={download} alt="" /> Export
              </button>
            </div>
          </div>

          <div>
            <div
              className="ag-theme-alpine"
              style={{ width: "100%", height: "70vh" }}
                      >
                          <SBGrid
                              ref={transactionsRef}
                              column={colDef}
                              row={TransactionListData}
                              pageSize={15}
                              rowSelection="single"
                              filters={appliedFilter}
                              componentID={1007}
                              gridStyle={{ width: "100%", height: "700px" }}
                          ></SBGrid>
            </div>
          </div>
        </div>
      </div>
             {/* View Delete Modal ----- */}
             <Modal show={showdeleteModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowdeleteModal(false);
          }}
        >
          <Modal.Title>
            Delete Transaction
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Do you want delete this Transaction?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
                setShowdeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={deleteTransactionById}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer/>
    </>
  );
}
